import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('web-interactives-dashboard-ui');